import { render } from "./documents_editor_redact.vue?vue&type=template&id=fa3924b6"
import script from "./documents_editor_redact.vue?vue&type=script&lang=js"
export * from "./documents_editor_redact.vue?vue&type=script&lang=js"

import exportComponent from "/opt/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__